/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-multi-comp */
import { Grid } from '@mui/material';
import React, { useState } from 'react';
import { WeekDays } from '~/Models/DTO/Provider.model';
import { OpeningHoursSectionStyles } from '..';
import { IErrorWeekdays } from '../OpeningHoursSection';
import {
  OpeningHoursSectionTableCloseRow,
  OpeningHoursSectionTableHeader,
  OpeningHoursSectionTableRow,
} from '.';
import { useModalHelper } from '~/Hooks/useModal';
import { OpeningHoursSectionDayModal } from './OpeningHoursSectionDayModal';

export interface OpeningHoursSectionTableMobileProps {
  weekdays: string[];
  displayWeekdays: WeekDays;
  errorWeekdays: IErrorWeekdays;
  onToggleDay: (day: string, timeIndex?: number) => void;
  onAddTime: (day: string) => void;
  onTimeChange: (day: string, timeRowIndex: number, type: 'from' | 'to', value: any) => void;
  onCopyToAll?: () => void;
}

export const OpeningHoursSectionTableMobile = ({
  weekdays,
  displayWeekdays,
  onToggleDay,
  onAddTime,
  onTimeChange,
  errorWeekdays,
}: OpeningHoursSectionTableMobileProps) => {
  const { classes } = OpeningHoursSectionStyles();
  const { isOpen: showDayModal, close: closeDayModal, open: handleDayModaOpen } = useModalHelper(
    false,
  );
  const [currentDayInState, setCurrentDayInState] = useState<string>('');
  const handleOpenDayModal = (currentDay: string) => {
    setCurrentDayInState(currentDay);
    handleDayModaOpen();
  };

  return (
    <div className={classes.container}>
      <React.Fragment>
        <OpeningHoursSectionTableHeader />

        {weekdays.map((day) => (
          <Grid
            data-testid="opening-hours-section-days"
            key={day}
            container
            className={classes.row}
          >
            {displayWeekdays[day].length > 0 ? (
              <OpeningHoursSectionTableRow
                dataTable={displayWeekdays[day]}
                currentDay={day}
                onOpenDayModal={handleOpenDayModal}
              />
            ) : (
              <OpeningHoursSectionTableCloseRow
                currentDay={day}
                onOpenDayModal={handleOpenDayModal}
              />
            )}
          </Grid>
        ))}
        <OpeningHoursSectionDayModal
          currentDay={currentDayInState}
          onToggleDay={onToggleDay}
          open={showDayModal}
          onClose={closeDayModal}
          displayWeekdays={displayWeekdays}
          errorWeekdays={errorWeekdays}
          onTimeChange={onTimeChange}
          onAddTime={onAddTime}
        />
      </React.Fragment>
    </div>
  );
};
